module.exports = __webpack_public_path__ + "static/media/info09_Capsula_de_induccion.1d17d8b4.png";